import React from 'react'
import DisplayExitWorkers from '../components/WorkerBioData/DisplayExitWorkers'

export default function ExistingWorker() {
  return (
    <div className="layout-body">
    <DisplayExitWorkers/>
    </div>
  )
}
